import React, { useMemo } from 'react';
import styles from './TipHeader.module.scss';
import SVG from 'react-inlinesvg';

/* Interfaces */
import { PriceType } from '../../../../TipPublish/interfaces/utils';

/* Translations */
import { useTranslation } from 'react-i18next';
import { tr } from '../../../../../utils/translations/translator';

/* Assets */
import boltIcon from '../../../../../assets/icons/tips/bolt.svg';

interface TipHeaderProps {
  type: PriceType;
}

export const TipHeader: React.FC<TipHeaderProps> = ({ type }) => {
  const { t } = useTranslation();

  const translationKey = useMemo(() => {
    //TODO: match keys on lokalise & get type from context
    const LIST_OF_KEYS: Record<PriceType, string> = {
      PAID: 'SAFE',
      FREE: 'FREE',
      PREMIUM: 'premium',
    };

    return LIST_OF_KEYS[type];
  }, [type]);

  return (
    <div className={styles.header}>
      <SVG className={styles.icon} src={boltIcon} />
      <span className={styles.text}>{tr(t, translationKey).toUpperCase()}</span>
    </div>
  );
};
